export const APP_SET_DEVICE = 'APP_SET_DEVICE'
export const SET_AGREE = 'SET_AGREE'
export const ORDER_AGAIN = 'ORDER_AGAIN'
export const SET_DATE = 'SET_DATE'
export const SET_TIME = 'SET_TIME'
export const SET_MOBILE_STEP = 'SET_MOBILE_STEP'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_BIG_BOTTLES = 'SET_BIG_BOTTLES'
export const SET_SMALL_BOTTLES1 = 'SET_SMALL_BOTTLES1'
export const SET_SMALL_BOTTLES2 = 'SET_SMALL_BOTTLES2'